<template>
  <div class="uidesign-customer">
    <div :style="{backgroundColor: projectUiData.backgroundColorRight}" class="customer-uidescription-textdiv">
      <div class="customer-uidesign-textdiv">
        <div style="display: flex">
          <h1 :style="{color: projectUiData.titleColor}" class="customer-ui-title">{{ projectUiData.titleUi }}<h1 class="customer-designui-title">DESIGN</h1></h1>
          <img :src="projectUiData.titleImageAbove" class="customer-uidesign-titleimageabove">
        </div>
        <p class="customer-uidesign-text">{{ projectUiData.uiDesignText }}</p>
        <img :src="projectUiData.titleImageUnder">
        <img :src="images[imageIndex]" class="customer-uidescription-image" v-if="window.innerWidth < 600">
      </div>
    </div>
    <div :style="{backgroundColor: projectUiData.backgroundColorLeft}" class="customer-uidescription-imagediv">
        <img :src="images[imageIndex]" class="customer-uidescription-image">
      <div class="customer-uidesign-buttondiv">
        <div v-if="images.length > 1" class="customer-uidesign-button" @click="changeImage(index)" v-for="(image, index) in images" :id="index"
             :style="{color: index === imageIndex ? projectUiData.colorNew : 'white'}">
          <img :src="projectUiData.image" v-if="index === imageIndex">
          {{index + 1}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'CustomerUIDescription',
    props: {
      projectUiData: {
        backgroundColorLeft: String,
        backgroundColorRight: String,
        titleUi: String,
        titleColor: String,
        uiDesignImages: Array,
        uiDesignMobileImages: Array,
        colorNew: String,
        image: String,
        titleImageAbove: String,
        uiDesignText: String,
        titleImageUnder: String
      }
    },
    data() {
      return {
        images: this.projectUiData.uiDesignImages,
        chosenimage: "",
        imageIndex: 0,
        window
      }
    },
    methods:
      {
        changeImage: function (index) {
          //console.log(this);
          this.imageIndex = index;
        }
      },
    created() {
      this.images = window.innerWidth > 600 ? this.projectUiData.uiDesignImages : this.projectUiData.uiDesignMobileImages
    }
  }

</script>
<style lang="scss" scoped>
  @import "../../assets/scss/customerUIDesign.scss";
</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerUIDesign.vue